import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/trackers/")({
  head: () => ({
    meta: [{ title: "Reactor | Trackers" }],
  }),
  component: TrackersPage,
});

function TrackersPage() {
  return <Navigate to="/trackers/wallets" />;
}
